import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './app/App'
import { TelegramProvider } from './shared/auth/TelegramProvider'
import { OrdersProvider } from './shared/providers/OrdersProvider'
import { checkAuthOnStartup } from './shared/auth/initAuth'
import './index.css'

// Инициализируем глобальный WebSocket
import './shared/ws/globalWebSocket'
import { logger } from './shared/utils/logger'

// 🔥 ТЕСТ КОНСОЛИ
console.log('🔥 ТЕСТ: Console.log работает!')
console.warn('🔥 ТЕСТ: Console.warn работает!')
console.error('🔥 ТЕСТ: Console.error работает!')

// 🔥 ДИАГНОСТИКА: Логируем начальное состояние
logger.log('🔥 ДИАГНОСТИКА: React приложение запускается', {
  url: window.location.href,
  pathname: window.location.pathname,
  search: window.location.search,
  hash: window.location.hash,
  userAgent: navigator.userAgent,
  hasTelegramObject: !!(window as any)?.Telegram,
  hasWebApp: !!(window as any)?.Telegram?.WebApp,
  timestamp: new Date().toISOString()
})

// ВРЕМЕННО ОТКЛЮЧЕН - Подавляем Telegram WebView логи глобально только в development
// if (logger.isEnabled()) {
//   const originalConsoleLog = console.log
//   console.log = (...args: any[]) => {
//     const message = args.join(' ')
//     // Фильтруем все логи от Telegram WebView
//     if (message.includes('[Telegram.WebView]') || 
//         message.includes('postEvent') || 
//         message.includes('receiveEvent') ||
//         message.includes('web_app_') ||
//         message.includes('theme_changed') ||
//         message.includes('viewport_changed') ||
//         message.includes('safe_area_changed')) {
//       return // Не выводим эти логи
//     }
//     // Остальные логи выводим как обычно
//     originalConsoleLog.apply(console, args)
//   }
// }

// Инициализация авторизации при старте приложения
checkAuthOnStartup().then((isAuthenticated) => {
  logger.log('✅ Инициализация авторизации завершена:', isAuthenticated)
}).catch((error) => {
  logger.error('❌ Ошибка при инициализации авторизации:', error)
})

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TelegramProvider>
      <OrdersProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </OrdersProvider>
    </TelegramProvider>
  </React.StrictMode>
)
